import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Field from '../../../../../../../../../../components/Form/Field'
import ErrorMessage from '../../../../../../../../../../components/Form/ErrorMessage'

import { getUnitTypeLabel } from '../../../../../formatters/formatUnitType'
import { useRemainingBudgetValidation } from '../../../../../hooks/remainingBudgetHooks'
import { formatNumber } from '../../../../../../../../../../helpers/numbers'
import { getIsBudgetAllocationType } from '../../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/helpers'

import { rightSelector } from '../../../../../../../../../../modules/selectors/rights'

import { UNITS } from '../../../../../fields'
import {
  BILLING_EVENT,
  GOOGLE_AD_MANAGER_AD_ACCOUNT
} from '../../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'
import { selectedPartnershipSelector } from '../../../../../../../../../../modules/selectors/partnerships'

const UnitsField = ({ formik, forecastErrorMessage }) => {
  const { t } = useTranslation()

  const right = useSelector(rightSelector)
  const { [GOOGLE_AD_MANAGER_AD_ACCOUNT]: gamAccount } = useSelector(selectedPartnershipSelector)
  const currencySymbol = gamAccount?.currency_symbol || ''
  const unitTypeLabel = getUnitTypeLabel(right[BILLING_EVENT])

  const { remainingBudget } = useRemainingBudgetValidation()
  const isBudgetAllocationType = getIsBudgetAllocationType(right)

  return (
    <>
      {isBudgetAllocationType ? (
        <>
          <p>{t(`Enter budget.`)}</p>
          <p>{t(`Remaining budget: ${currencySymbol}${formatNumber(remainingBudget, { max: 2 })}`)}</p>

          <Field
            type="number"
            formik={formik}
            name={UNITS}
            placeholder={`Budget`}
            autoComplete="off"
            symbol={currencySymbol}
          />
        </>
      ) : (
        <>
          <p>{t(`Enter ${unitTypeLabel} budget.`)}</p>
          <p>{t(`Remaining ${unitTypeLabel}: ${formatNumber(remainingBudget, { max: 2 })}`)}</p>

          <Field
            type="number"
            formik={formik}
            name={UNITS}
            placeholder={`${unitTypeLabel} budget`}
            autoComplete="off"
          />
        </>
      )}
      {forecastErrorMessage && <ErrorMessage error={forecastErrorMessage} />}
    </>
  )
}

export default UnitsField
